module.exports = __webpack_public_path__ + "img/ic_region_pin.be59ef9d.svg";